export default "__VITE_ASSET__0306d910__"